module.exports = __webpack_public_path__ + "img/astral-txt_22.25cf6481.svg";